import React from "react";
import { useFela } from "react-fela";

import { Grid } from "@/components/Grid";
import { useTheme } from "@/hooks/useTheme";
import { Heading } from "@/components/Heading";
import { LinkButton } from "@/components/LinkButton";
import { Image } from "@/components/Image";
import { ISupportFeaturesSection } from "./types";

type IProps = ISupportFeaturesSection & JSX.IntrinsicElements["div"];

export const SupportFeaturesSection: React.FC<IProps> = ({
  title,
  subtitle,
  elements,
  cta,
  ...rest
}) => {
  const { css } = useFela();
  const { colors, bp } = useTheme();

  return (
    <Grid
      customStyle={{ flexDirection: "column", position: "relative" }}
      background="GHOST_WHITE"
      {...rest}
      id="SupportFeaturesSection"
    >
      <div className={css({ textAlign: "center" })}>
        <Heading as="h2">{title}</Heading>
        <Heading as="h4" customStyle={{ fontWeight: 400 }}>
          {subtitle}
        </Heading>
      </div>

      <div
        className={css({
          display: "flex",
          justifyContent: "space-between",
          flexWrap: "wrap",
          margin: "64px 0",
          [bp.FROM_TABLET]: {
            flexWrap: "nowrap",
          },
        })}
      >
        {elements.map(({ src, title, text }) => (
          <div
            key={src}
            className={css({
              width: "100%",
              padding: "32px 24px",
              backgroundColor: "#fffffe",
              borderRadius: 6,
              filter: "drop-shadow(0px 8px 20px rgba(0, 0, 0, 0.06))",
              nested: {
                ":not(:last-child)": {
                  marginBottom: 30,
                },
              },
              [bp.FROM_TABLET]: {
                width: "calc(33% - 30px)",
                nested: {
                  ":not(:last-child)": {
                    marginRight: 30,
                    marginBottom: 0,
                  },
                },
              },
            })}
          >
            <Image
              src={src}
              customStyle={{ width: "100%", marginBottom: 24 }}
            />
            <Heading as="h3">{title}</Heading>
            <p
              className={css({
                marginTop: -20,
                color: colors.GRAY,
                fontSize: 14,
                lineHeight: "22px",
              })}
            >
              {text}
            </p>
          </div>
        ))}
      </div>

      {cta && (
        <LinkButton
          customStyle={{ width: "fit-content", margin: "0 auto" }}
          {...cta}
        />
      )}
    </Grid>
  );
};
